<section class="w3l-form-25">
  <div class="form-inner-cont">
      <div class="w3l-form-25">
          <h1>Patient General Data</h1>
          <p>Enter Personal Data  </p>
      </div>
</div>
</section>
<section class="w3l-hero-headers-11 p-sticky-md">
  <div class="top-header">
          <div class="d-grid grid-columns-top-3">
              <div class="accounts">
                  <ul>
                      <li></li>
                      <li></li>
                  </ul>
              </div>
              <div class="search">
                  <form action="search-results.html" method="get">
                      <input id="search" name="search" type="text" placeholder="Search.." required="">
                      <button type="submit"><span class="fa fa-search" aria-hidden="true"></span></button>
                  </form>
              </div>
          </div>
  </div>
</section>
<div id="w3l-appointment">
<section class="appointment-section section-gap">

<div class="wrapper">
<div class="d-grid doctor-appointment">
    <div class="appointment-form">
        <form action="#" method="post">
            <div class="fields-grid">

              <div class="styled-input">
                <label>Date of Diagnosis</label>

                  <div class="appointment-form-field">
                      <span class="fa fa-calendar" aria-hidden="true"></span>
                      <input type="date" [(ngModel)]="currentdate" name="DateofDiagnosis" required style="width: 50%;">

                  </div>
                </div>

              <div class="styled-input">
                <label>M.R.N</label>
                <div class="appointment-form-field">
                    <span class="fa fa-search" aria-hidden="true"></span>
                    <input type="text" name="PatientCode" placeholder="Patient Code" required="" style="width: 30%;">

                </div>
              </div>
              <div class="styled-input">
                <label>Patient Name</label>
                <div class="appointment-form-field">
                    <span class="fa fa-user" aria-hidden="true"></span>
                    <input type="text" name="PatientName" placeholder="Patient Name" required="">

                </div>
              </div>
              <div class="styled-input">
                <label>Diagnosis</label>
                <br>
                    <br>
                <div class="appointment-form-field">
                  <span class="fa fa-line-chart" aria-hidden="true" style="height: 200%;"></span>
                  <textarea rows = "5" cols = "60" name = "Diagnosis" class="appointment-form-field" style="height: 200%;"> Enter details here... </textarea><br>

                </div>
              </div>
              <div class="styled-input">
                <label>Date of Birth</label>

                  <div class="appointment-form-field">
                      <span class="fa fa-calendar" aria-hidden="true"></span>
                      <input type="date" name="BirthDate" required >
                      <label> </label>
                      <label>Age</label>
                      <div class="appointment-form-field">

                          <input type="text" name="age" required style="width: 15%;" readonly>

                      </div>

                  </div>
                </div>

                <div class="styled-input">
                  <label>Sites</label>
                  <div class="appointment-form-field">
                      <span class="fa fa-laptop" aria-hidden="true"></span>
                      <select id="Sites" required>
                        <option value="0">COC</option>
                        <option value="1">Elshoroq</option>

                    </select>
                  </div>
                </div>
                <div class="styled-input">
                  <label>Cancer Type</label>
                  <div class="appointment-form-field">
                      <span class="fa fa-heartbeat" aria-hidden="true"></span>
                      <select id="CancerType" required>
                          <option value="0">cancer1</option>
                          <option value="1">cancer2</option>
                          <option value="2">cancer3</option>

                      </select>
                  </div>
              </div>
              <div class="styled-input">
                <label>Pathology</label>
                <div class="appointment-form-field">
                    <span class="fa fa-bookmark" aria-hidden="true"></span>
                    <select id="Pathology" required>
                        <option value="0">Pathology1</option>
                        <option value="1">Pathology2</option>
                        <option value="2">Pathology3</option>

                    </select>
                </div>
            </div>
            <div class="styled-input">
              <label>Master Status</label>
              <div class="appointment-form-field">
                  <span class="fa fa-pencil-square-o" aria-hidden="true"></span>
                  <select id="Masterstatus" required>
                      <option value="0">Status1</option>
                      <option value="1">Status2</option>
                      <option value="2">Status3</option>

                  </select>
              </div>
          </div>
              <div class="styled-input">


                    <label>Address</label>
                    <br>
                    <br>

                    <div class="appointment-form-field">
                        <span class="fa fa-university" aria-hidden="true" style="height: 200%;"></span>
                        <textarea rows = "5" cols = "60" name = "Address" class="appointment-form-field" style="height: 200%;"> Enter details here... </textarea><br>
                    </div>
                </div>


                <div class="clear"> </div>
            </div>
        </form>
    </div>


  <div class="fields-grid">

    <div class="styled-input">
      <label>Marital Status</label>
      <div class="appointment-form-field">
          <span class="fa fa-street-view" aria-hidden="true"></span>
          <select id="Maritalstatus" required style="width: 25%">
              <option value="0">Single</option>
              <option value="1">Married</option>
              <option value="2">Divorced</option>
              <option value="3">Widow/Widower</option>

          </select>

          <span class="fa fa-user-plus" aria-hidden="true"></span>
          <select id="Maritalstatus" required style="width: 25%">
              <option value="0">Male</option>
              <option value="1">Female</option>


          </select>


      </div>


  </div>

    <div class="styled-input">
      <label>Doctor</label>
      <div class="appointment-form-field">
          <span class="fa fa-headphones" aria-hidden="true"></span>
          <select id="Doctor" required>
              <option value="0">Doctor</option>
              <option value="1">Ahmed</option>
              <option value="2">Mohamed</option>
              <option value="3">Ayman</option>
              <option value="4">Islam</option>
          </select>
      </div>
  </div>
  <div class="styled-input">
    <label>Education</label>
    <div class="appointment-form-field">
        <span class="	fa fa-mortar-board" aria-hidden="true"></span>
        <select id="Education" required >
            <option value="0">Education1</option>
            <option value="1">Education2</option>
            <option value="2">Education3</option>
            <option value="3">Education4/Widower</option>

        </select>

    </div>

</div>
<div class="styled-input">
  <label>Nationality</label>
  <div class="appointment-form-field">
      <span class="fa fa-flag" aria-hidden="true"></span>
      <select id="Nationality" required >
          <option value="0">Nationality1</option>
          <option value="1">Nationality2</option>
          <option value="2">Nationality3</option>
          <option value="3">Nationality4/Widower</option>

      </select>

  </div>

</div>
<Br>
<div class="styled-input">
  <label>Governorate</label>
  <div class="appointment-form-field">
      <span class="fa fa-map-marker" aria-hidden="true"></span>
      <select id="Governorate" required >
          <option value="0">Cairo</option>
          <option value="1">Giza</option>
          <option value="2">Asswan</option>
          <option value="3">Sohag/Widower</option>

      </select>

  </div>

</div>
<div class="styled-input">
  <label>Occupation</label>
  <div class="appointment-form-field">
      <span class="fa fa-handshake-o" aria-hidden="false"></span>
      <input type="text" id="Accupation" required >


  </div>

</div>

<div class="styled-input">
  <label>Email</label>
  <div class="appointment-form-field">
      <span class="fa fa-send" aria-hidden="false"></span>
      <input type="text" id="Email" required >


  </div>

</div>
<div class="styled-input">
  <label>Tel1</label>
  <div class="appointment-form-field">
      <span class="fa fa-phone" aria-hidden="false"></span>
      <input type="text" id="Tel1" required >


  </div>

</div>
<div class="styled-input">
  <label>Tel2</label>
  <div class="appointment-form-field">
      <span class="fa fa-phone" aria-hidden="false"></span>
      <input type="text" id="Tel2" required >


  </div>

</div>
<div class="styled-input">
  <label>Mobile</label>
  <div class="appointment-form-field">
      <span class="fa fa-mobile" aria-hidden="false"></span>
      <input type="text" id="Tel3" required >
  </div>
</div>

</div>



</div>
<div class="clear"> </div>
</div>
</section>
</div>
<div id="w3l-appointment">

  <div class="wrapper">
  <div class="d-grid doctor-appointment">
      <div class="appointment-form">
  <button type="button" class="theme-button btn" name="submit">Submit</button>
  <button type="button" class="theme-button btn" name="Delete">Delete</button>
  <button type="button" class="theme-button btn" name="New">Next</button>
  <a href="Home">
    <button type="button" class="theme-button btn" style="width: 83%;" name="Back">Home</button>
  </a>
</div>


</div>



